<div class="tutorial-item-list" [ngClass]="{'admin':isAdmin}">
  <div class="">
    <button (click)="voltar()" class="btn return-button"><span class="font-icon">undo</span> Voltar</button>
  </div>
  <div class="header-title" [style]="{'backgroundColor':'#' + data?.color }">
    <h2>{{data?.title}}</h2>
    <span class="description">{{data?.description}}</span>
    <button (click)="openColorModal()" *ngIf="isAdmin" class="btn color-button font-icon">palette</button>
  </div>
  <app-tutorial-item-list [isAdmin]="isAdmin" [isOrdering]="isOrdering" [data]="data?.tutorial_class" type="material"
    (saveList)="saveList($event)" (deleteList)="deleteList($event)" (excluir)="excluir($event)" (openModal)="openModal($event)"
    (changeShow)="changeShow($event)" (openItem)="openFile($event)"></app-tutorial-item-list>
</div>

<ng-template #modal>
  <app-tutorial-material-edit [id]="currentItemId" [tutorialId]="id" (closeModal)="closeModal(modalRef)" ></app-tutorial-material-edit>
</ng-template>

<ng-template #modal_color>
  <app-tutorial-edit-color [id]="id" (closeModal)="closeModal(modalColorRef)" ></app-tutorial-edit-color>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>